import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Reports } from "components/reports/reports";
import { fetchReportsAction, submitReportAction } from "actions/reports-actions";
import { trackPageAction } from "actions/shared/tracking-actions";

class ReportsPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
    this.props.trackPage();
  }

  render() {
    return (
      <div>
        <Reports { ...this.props } />
      </div>
    );
  }
}

ReportsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  categories: state.categories.categories,
  currency: state.accountSettings.currency,
  newReport: state.reports.newReport,
  reports: state.reports.reports,
  vendors: state.vendors.vendors
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchReportsAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Reports page")),
  onSubmitReport: (e) => dispatch(submitReportAction(e))
});

export const ReportsContainer = connect(mapStateToProps, mapDispatchToProps)(ReportsPage);



// WEBPACK FOOTER //
// ./src/js/containers/reports-container.jsx